import { render, staticRenderFns } from "./UserInjuryFilter.vue?vue&type=template&id=d7697d62&"
import script from "./UserInjuryFilter.vue?vue&type=script&lang=js&"
export * from "./UserInjuryFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports